export default __webpack_public_path__ + "static/media/MielOrganica.8572f80c.jpeg";